{
  "name": "connect-my-club",
  "version": "4.0.8",
  "build": "468",
  "author": "connectMyClub",
  "homepage": "https://members.connectmyclub.co.uk",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --watch",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "lint": "ng lint",
    "ionic:build": "npm run build",
    "ionic:serve": "npm run start -- --configuration development",
    "ionic:serve_prod": "npm run start  -- --configuration=production --project=app",
    "copysqlwasm": "copyfiles -u 3 node_modules/sql.js/dist/sql-wasm.wasm src/assets"
  },
  "config": {
    "ionic_webpack": "./config/webpack.config.js"
  },
  "private": true,
  "dependencies": {
    "@angular/cdk": "19.2.19",
    "@angular/common": "^19.2.15",
    "@angular/core": "^19.2.15",
    "@angular/forms": "^19.2.15",
    "@angular/google-maps": "19.2.19",
    "@angular/platform-browser": "^19.2.15",
    "@angular/platform-browser-dynamic": "^19.2.15",
    "@angular/router": "^19.2.15",
    "@angular/service-worker": "^19.2.15",
    "@awesome-cordova-plugins/calendar": "8.1.0",
    "@awesome-cordova-plugins/core": "8.1.0",
    "@capacitor-community/file-opener": "7.0.1",
    "@capacitor-community/in-app-review": "7.0.1",
    "@capacitor-community/screen-brightness": "^7.0.0",
    "@capacitor-community/sqlite": "7.0.2",
    "@capacitor-community/stripe": "7.2.1",
    "@capacitor-firebase/messaging": "7.3.1",
    "@capacitor/android": "7.4.3",
    "@capacitor/app": "7.1.0",
    "@capacitor/barcode-scanner": "2.2.0",
    "@capacitor/browser": "7.0.2",
    "@capacitor/camera": "7.0.2",
    "@capacitor/configure": "2.0.10",
    "@capacitor/core": "7.4.3",
    "@capacitor/device": "7.0.2",
    "@capacitor/dialog": "7.0.2",
    "@capacitor/filesystem": "^7.1.4",
    "@capacitor/geolocation": "7.1.5",
    "@capacitor/haptics": "7.0.2",
    "@capacitor/ios": "7.4.3",
    "@capacitor/keyboard": "7.0.3",
    "@capacitor/network": "7.0.2",
    "@capacitor/preferences": "7.0.2",
    "@capacitor/share": "^7.0.2",
    "@capacitor/splash-screen": "7.0.3",
    "@capacitor/status-bar": "7.0.3",
    "@capawesome/capacitor-android-edge-to-edge-support": "^7.2.3",
    "@capawesome/capacitor-app-update": "7.0.1",
    "@capawesome/capacitor-badge": "7.0.1",
    "@ebarooni/capacitor-calendar": "^7.2.0",
    "@fortawesome/angular-fontawesome": "1.0.0",
    "@fortawesome/fontawesome-svg-core": "6.7.2",
    "@fortawesome/free-brands-svg-icons": "6.7.2",
    "@fortawesome/free-solid-svg-icons": "6.7.2",
    "@fortawesome/pro-duotone-svg-icons": "6.7.2",
    "@fortawesome/pro-light-svg-icons": "6.7.2",
    "@fortawesome/pro-regular-svg-icons": "6.7.2",
    "@ionic/angular": "8.7.7",
    "@ionic/cli": "^7.2.0",
    "@ionic/core": "8.7.7",
    "@ionic/pwa-elements": "^3.2.2",
    "@stripe/stripe-js": "8.1.0",
    "@types/google-maps": "^3.2.3",
    "autolinker": "4.0.0",
    "capacitor-blob-writer": "1.1.19",
    "capacitor-ios-autofill-save-password": "5.0.0",
    "capacitor-native-settings": "7.0.2",
    "chart.js": "4.4.4",
    "cordova": "12.0.0",
    "cordova-browser": "7.0.0",
    "cordova-plugin-calendar": "5.1.6",
    "date-fns": "^2.3.0",
    "firebase": "11.10.0",
    "hammerjs": "^2.0.8",
    "jeep-sqlite": "^2.8.0",
    "ngx-linky": "^4.0.0",
    "pinch-zoom-js": "^2.3.5",
    "plugin": "^0.3.3",
    "rxjs": "7.8.1",
    "save": "^2.9.0",
    "sql.js": "1.13.0",
    "stripe-pwa-elements": "^2.1.0",
    "swiper": "12.0.2",
    "tslib": "^2.2.0",
    "zone.js": "0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "19.2.17",
    "@angular-eslint/builder": "19.8.1",
    "@angular-eslint/eslint-plugin": "19.8.1",
    "@angular-eslint/eslint-plugin-template": "19.8.1",
    "@angular-eslint/template-parser": "19.8.1",
    "@angular/cli": "19.2.17",
    "@angular/compiler": "^19.2.15",
    "@angular/compiler-cli": "^19.2.15",
    "@angular/language-service": "19.2.15",
    "@capacitor/assets": "^3.0.5",
    "@capacitor/cli": "7.4.3",
    "@esbuild/darwin-arm64": "^0.25.11",
    "@ionic/angular-toolkit": "12.3.0",
    "@ionic/lab": "3.2.15",
    "@types/jasmine": "5.1.4",
    "@types/jasminewd2": "2.0.13",
    "@types/node": "^22.5.0",
    "@typescript-eslint/eslint-plugin": "8.3.0",
    "@typescript-eslint/parser": "8.3.0",
    "copyfiles": "^2.4.1",
    "eslint": "8.57.0",
    "eslint-plugin-import": "2.28.1",
    "eslint-plugin-jsdoc": "46.8.2",
    "eslint-plugin-prefer-arrow": "1.2.3",
    "jasmine-core": "5.1.1",
    "jasmine-spec-reporter": "7.0.0",
    "karma": "6.4.2",
    "karma-chrome-launcher": "3.2.0",
    "karma-coverage": "2.2.1",
    "karma-coverage-istanbul-reporter": "~3.0.2",
    "karma-jasmine": "5.1.0",
    "karma-jasmine-html-reporter": "2.1.0",
    "protractor": "~7.0.0",
    "replace-in-file": "^8.3.0",
    "ts-node": "10.9.2",
    "typescript": "5.5.4"
  },
  "description": "connectMyClub project",
  "browserslist": [
    "Chrome >=89",
    "ChromeAndroid >=89",
    "Firefox >=75",
    "Edge >=89",
    "Safari >=15",
    "iOS >=15"
  ],
  "packageManager": "yarn@1.22.22+sha512.a6b2f7906b721bba3d67d4aff083df04dad64c399707841b7acf00f6b133b7ac24255f2652fa22ae3534329dc6180534e98d17432037ff6fd140556e2bb3137e"
}
